import React from "react";
import { Form, FormGroup, FormLabel, FormControl, Col } from "react-bootstrap";
import PropTypes from "prop-types";

const PlainTextField = React.forwardRef((props, ref) => {
  return props.inline ? (
    <FormGroup as={Form.Row}>
      <FormLabel column>{props.label}</FormLabel>
      <Col>
        <FormControl plaintext readOnly defaultValue={props.value} ref={ref} />
      </Col>
    </FormGroup>
  ) : (
    <FormGroup>
      <FormLabel>{props.label}</FormLabel>
      <FormControl plaintext readOnly defaultValue={props.value} ref={ref} />
    </FormGroup>
  );
});

PlainTextField.propTypes = {
  inline: PropTypes.bool,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default PlainTextField;
